import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { LayoutInitService } from 'src/app/RefModules/_metronic/core';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false,
})
export class ContactUsComponent implements OnInit {
    checkRoute: boolean;
    isUserLoggedIn: boolean;

    constructor(
        private layoutService: LayoutInitService,
        private router: ActivatedRoute,
        private msalService: MsalService
    ) {
        this.isUserLoggedIn = false;
    }

    ngOnInit(): void {
        this.layoutService.init();
        this.isUserLoggedIn = this.msalService.instance.getActiveAccount() ? true : false;
        this.checkRoute = this.router.routeConfig.path === 'contactUs' ? true : false;
    }
}
